'use client';

import { useMemo, useRef, type ReactNode } from 'react';
import {
  ChatExpansionContext,
  type ChatExpansionStore,
} from './chat-expansion-state';

export function ChatExpansionProvider({ children }: { children: ReactNode }) {
  const expansionByKeyRef = useRef(new Map<string, boolean>());
  const store = useMemo<ChatExpansionStore>(
    () => ({
      read: (expansionKey) => expansionByKeyRef.current.get(expansionKey),
      write: (expansionKey, isExpanded) => {
        expansionByKeyRef.current.set(expansionKey, isExpanded);
      },
    }),
    [],
  );

  return (
    <ChatExpansionContext.Provider value={store}>
      {children}
    </ChatExpansionContext.Provider>
  );
}
